import { Actions, Dispatchers, EmptyObject, F1 } from './types';
import { Parametrize } from './types';

export const extendDispatch = <T2 extends EmptyObject>(d: F1<Actions<T2>>) => {
  const dispatch = <T extends keyof T2>(type: T, payload: T2[T]) =>
    d({ type, payload } as Actions<T2>);
  const lazyDispatch =
    <T extends keyof T2>(type: T, payload: T2[T]) =>
    () =>
      dispatch(type, payload);
  return { dispatch, lazyDispatch };
};

export const getDispatchers = <T2 extends Record<string, any>>(
  orgDispatch: (v: Actions<T2>) => void,
): Dispatchers<T2> => {
  return {
    dispatch: <T extends keyof T2>(type: T, ...args: Parametrize<T2[T]>) => {
      const payload = args.length > 0 ? args[0] : (null as T2[T]);
      orgDispatch({ type, payload } as Actions<T2>);
    },

    lazyDispatch:
      <T extends keyof T2>(type: T) =>
      (...args: Parametrize<T2[T]>) => {
        const payload = args.length > 0 ? args[0] : (null as T2[T]);
        orgDispatch({ type, payload } as Actions<T2>);
      },
  };
};
